import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CustomSnackbarData } from '@shared/types/custom-snackbar-data.type';

@Component({
  imports: [CommonModule, MatIconModule, MatButtonModule],
  selector: 'wcg-custom-snackbar',
  styleUrl: './custom-snackbar.component.css',
  templateUrl: './custom-snackbar.component.html',
})
export class CustomSnackbarComponent {
  private readonly _router = inject(Router);
  public readonly data = inject<CustomSnackbarData>(MAT_SNACK_BAR_DATA);
  public readonly snackBarRef = inject(MatSnackBarRef<CustomSnackbarComponent>);

  onNavigate(event: Event) {
    event.preventDefault();
    this.snackBarRef.dismiss();
    this._router.navigate([this.data.navigateTo]);
  }
}
